import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import { rooms } from "./Rooms";
import { Link } from "react-router-dom";

const RoomCarousel = () => {
  const { t } = useTranslation();
  const sliderRef = useRef(null); // Tạo tham chiếu đến Slider

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="py-12 px-6">
      <div className="text-center mb-6 flex flex-col justify-center">
        <h2 className="text-[30px] font-medium font-cormorant text-[#D4AF37]">
          {t("HOTEL_FEATURED_TITLE")}
        </h2>
        <p className="text-gray-600 font-[300] mt-2 font-cormorant text-[18px] mb-4 max-w-[700px] m-auto">
          {t("HOTEL_FEATURED_DESCRIPTION")}
        </p>
        <Link
          to={"/rooms"}
          className="border max-w-[200px] text-[14px] m-auto border-yellow-500 hover:bg-[#D4AF37] hover:text-white duration-200 text-gray-600 px-4 py-2 rounded font-greatVibes"
        >
          {t("LEARN_MORE")}
        </Link>
      </div>

      {/* Nút Prev và Next */}
      <div className="relative">
        <button
          className="absolute top-1/2 left-[-40px] transform -translate-y-1/2  text-black px-3 py-2 rounded-full transition"
          onClick={() => sliderRef.current.slickPrev()} // Gọi phương thức slickPrev
        >
          
        </button>
        <button
          className="absolute top-1/2 right-[-40px] transform -translate-y-1/2  text-black px-3 py-2 rounded-full transition"
          onClick={() => sliderRef.current.slickNext()} // Gọi phương thức slickNext
        >
         
        </button>

        <Slider ref={sliderRef} {...settings}>
          {rooms.map((room, index) => (
            <div key={index} className="p-4">
              <div className="w-80 bg-white rounded">
                <div className="h-[400px] w-[440px] overflow-hidden rounded">
                  <img
                    src={room.image[0]}
                    alt={room.title}
                    className="w-full h-full object-cover rounded hover:scale-110 duration-[0.5s]"
                  />
                </div>
                <h3 className="text-[17px] font-medium mt-2 font-cormorant">
                  {room.title}
                </h3>
                <p className="text-gray-600 font-cormorant text-[16px]">
                  {room.price}
                </p>
                <div className="mt-[9px]">
                  <Link
                    to={{
                      pathname: "/rooms/detail-rooms",
                      search: `?${room.type}`,
                    }}
                    className=" bg-[#D4AF37] text-black px-4 py-2 rounded font-greatVibes text-[14px]"
                  >
                    {t("VIEW_DETAILS")}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default RoomCarousel;
